import { StarIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export const ScaleRating = ({
  title,
  value,
}: {
  title: string;
  value: number | null;
}) => {
  const fullStars = Math.round(value ?? 0);
  const emptyStars = 5 - fullStars;
  const empty = value === null;
  return (
    <div
      className={cn(
        "flex w-full flex-col items-start gap-1",
        "md:flex-row md:items-center md:justify-between md:gap-4",
        empty && "text-zinc-300",
      )}
      key={title}
    >
      <h4 className={cn("text-sm", empty ? "text-zinc-300" : "text-zinc-950")}>
        {title}
      </h4>
      <div className={"flex items-center justify-start gap-1"}>
        {Array.from({ length: fullStars }).map((_, i) => (
          <StarIcon fill={"#FE9C08"} stroke={"#FE9C08"} size={"18px"} key={i} />
        ))}
        {Array.from({ length: emptyStars }).map((_, i) => (
          <StarIcon
            stroke={"#FE9C08"}
            className={empty ? "stroke-zinc-300" : ""}
            key={i}
            size={"18px"}
          />
        ))}
      </div>
    </div>
  );
};
